/**
 * NOTE: Manual AdSense logic has been deprecated in favour of Google Auto Ads.
 * This component is now a stub that renders nothing while keeping the import paths intact.
 */

import React from 'react';

const SmartAutoAds: React.FC<{ adKey?: string | number }> = () => null;

export default SmartAutoAds; 